export default __webpack_public_path__ + "static/media/wedding-thumbnail-3.958297c8.jpg";